module.exports = __webpack_public_path__ + "img/ring_g_c_null_0.ec9720a5.png";